export function getEnvironmentValue(environment) {
    switch (environment) {
        case 'stage':
            return 0;
        case 'prod':
            return 1;
        case 'testing':
            return 2;
        default:
            return '0';
    }
}
